import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {filterArrayUndefined} from '@coolcolduk/util';
import {NavigateFunction} from 'react-router';
import {env} from '../util/env/getEnvVar';

export const createWebsiteMenu = (navigate: NavigateFunction): AvatarMenuItem[] =>
  filterArrayUndefined([
    {
      label: 'Home',
      onClick: () => navigate('/'),
    },
    {
      label: 'Features',
      onClick: () => navigate('/features'),
    },
    env.subscribe
      ? {
          label: 'Pricing',
          onClick: () => navigate('/pricing'),
        }
      : undefined,
    {
      label: 'About',
      onClick: () => navigate('/about'),
    },
  ]);
